import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ScoreRegistrationLinkComponent } from './score-registration-link/score-registration-link.component';
import { ScoreRegistrationComponent } from './score-registration/score-registration.component';

const routes: Routes = [
     {
              path:'',component:ScoreRegistrationLinkComponent,
              children:[
                {
                  path:"scoreRegistration", component:ScoreRegistrationComponent
                },  
              ]
            }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ScoreRegistrationRoutingModule { }
